import { render } from "./ThePreloader.vue?vue&type=template&id=71b4a3fe"
import script from "./ThePreloader.vue?vue&type=script&lang=js"
export * from "./ThePreloader.vue?vue&type=script&lang=js"

import "./ThePreloader.vue?vue&type=style&index=0&id=71b4a3fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__